import { OcrInfoType, UploadFileObjType } from 'common/types';

import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const ocr = {
  checkUserInformation: async (params: { infoType: OcrInfoType; text?: string; imgUrl?: UploadFileObjType[] }) => {
    const { data, code } = await FastApiAxiosInstance.post('/api/v1/user/check/userInformation', params);

    /*
      {
        "code": 100006,
        "message": "易盾校验未通过",
        "data": {
          "e5642798-6bc1-40fe-a66f-0797d5e7785c": {
            "suggestion": 1,
            "label": 500,
            "dataId": "FAT_TR4690122893030492550"
          }
        }
      }
     */

    // code 为 0 时，接口调用正常，校验通过
    if (code === 0) {
      return true;
    } else {
      return false;
    }
  },
};
export default ocr;
